import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { PageMenu } from '../../../../components'
import { IconFiscalBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  FiscalPermissions,
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'
import { ROTAS_FISCAL } from '../../../../constants/fiscal'

function FiscalMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.FISCAL, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: FiscalPermissions.GESTAO_NFSE,
      content: { menu: '11.1 - Gestão de NFS-e', path: ROTAS_FISCAL.GESTAO_NFSE },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconFiscalBlue} alt="Icon Tela Fiscal" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>11. Fiscal</span>
      </PageMenu>{' '}
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(FiscalMenu))
